import React from "react";
import { Card } from "react-bootstrap";
import { GraphCardsHeader } from "@ui";
import PageNotFound from "views/PageNotFound";
import { findIcon } from "views/dashboard/icons";

const CardNotFound = ({
  title = "",
  height = "100%",
  width = "100%",
  isTitleCenter = false,
  tooltip = "",
}) => {
  return (
    <Card style={{ height: height, width: width }} className="flex-grow-1">
      <GraphCardsHeader
        title={title}
        titleCenter={isTitleCenter}
        tooltip={tooltip}
      />
      <Card.Body className="d-flex flex-grow-1 justify-content-center align-items-center">
        <PageNotFound
          title="No Data Found"
          backgroundImage={findIcon("Empty-folder", "dual-tone", 100)}
        />
      </Card.Body>
    </Card>
  );
};

export default CardNotFound;
